// extracted by mini-css-extract-plugin
module.exports = {"dialCode":"CountryDialCode_dialCode___h2BG"};